var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFb(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 72,
    viewBox: "0 0 75 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64.8929 0.94043H10.1064C4.5249 0.94043 0 5.17165 0 10.3913V61.6243C0 66.8439 4.52472 71.0751 10.1064 71.0751H37.1268L37.1729 46.0128H30.21C29.3052 46.0128 28.5707 45.3286 28.5673 44.4824L28.5339 36.4038C28.5304 35.5529 29.267 34.8615 30.1768 34.8615H37.127V27.0555C37.127 17.9967 43.0433 13.0641 51.6849 13.0641H58.776C59.6833 13.0641 60.419 13.7519 60.419 14.6005V21.4125C60.419 22.2607 59.6838 22.9483 58.7769 22.9489L54.4252 22.9507C49.7256 22.9507 48.8156 25.0391 48.8156 28.1038V34.8617H59.1422C60.1261 34.8617 60.8896 35.6652 60.7736 36.5789L59.7497 44.6576C59.6517 45.4306 58.9507 46.0131 58.1183 46.0131H48.8617L48.8156 71.0755H64.8932C70.4747 71.0755 74.9994 66.8442 74.9994 61.6248V10.3913C74.9993 5.17165 70.4745 0.94043 64.8929 0.94043Z",
    fill: "#475993"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFb);
export default __webpack_public_path__ + "static/media/fb.a72698e7da6646f28d1b52498b4506b9.svg";
export { ForwardRef as ReactComponent };